import React from 'react'
import { Button } from 'antd'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="vh-100 d-flex flex-column align-items-center justify-content-center gap-3">
          <img width="100px" src="/images/failed-document.svg" alt="404" />
          <h1 className="fs-4 m-0">Algo salió mal</h1>
          <pre
            style={{
              maxHeight: '200px',
              overflowY: 'auto',
              backgroundColor: '#1e1e1e',
              color: '#f8f8f2',
              padding: '10px',
              borderRadius: '6px',
              fontFamily: 'monospace',
              fontSize: '0.9rem',
              whiteSpace: 'pre-wrap',
            }}
          >
            {this.state.error?.toString()}
          </pre>
          <div className="d-flex flex-column align-items-center gap-3">
            <Button
              type="ghost"
              icon={<i className="fas fa-redo mr-2" />}
              onClick={this.handleReload}
            >
              Recargar la página
            </Button>
            {/* <span>
              o visita <a href="https://accordttechnology.com" target="_blank" rel="noopener noreferrer">
                ACCORD Technology
              </a>
            </span>*/}
          </div>
        </main>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary